import { mainColor, UNIT } from '../../constants/theme';

export const styles = () => ({
  addIcon: {
    fontSize: UNIT * 2,
    color: mainColor.secondaryColor,
    backgroundColor: 'transparent'
  },
  iconStyle: {
    fontSize: UNIT * 2
  },
  textStyle: { fontSize: UNIT * 0.625 },
  options: {
    fontSize: UNIT * 0.625,
    marginTop: 0,
    width: '100%',
    right: 0,
    bottom: 0
  },
  container: {
    flex: 'display',
    width: '100%',
    justifyContent: 'center',
    padding: UNIT * 1.25
  },
  body: { width: '100%' },

  modalStyle: {
    display: 'flex',
    flexDirection: 'column',
    padding: UNIT * 1.25,
    justifyContent: 'center',
    alignItems: 'center'
  },
  labelStyle: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    right: 0,
    bottom: 0
  },
  listOptions: {
    maxHeight: UNIT * 8.75,
    marginTop: UNIT * 0.625,
    marginLeft: UNIT * 1.25,
    marginRight: UNIT * 1.25,
    paddingLeft: UNIT * 0.625,
    borderRadius: UNIT,
    overflow: 'auto',
    border: '1px gray solid',
    position: 'relative'
  },
  firstItem: {
    borderRadius: UNIT,
    border: '3px solid',
    borderColor: 'gray',
    margin: UNIT * 0.6875,
    padding: UNIT * 1.25,
    width: UNIT * 11.71875,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    textAlign: 'center',
    alignItems: 'center',
    borderStyle: 'dashed',
    minHeight: UNIT * 21.25,
    maxHeight: UNIT * 25
  },
  categoryName: { alignSelf: 'center', marginTop: '5px' },
  checkbox: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    paddingTop: UNIT * 0.625
  },
  checkboxList: {
    display: 'flex',
    cursor: 'pointer',
    margin: -UNIT * 0.1875,
    marginRight: 0
  },
  subtitle: { fontSize: 10, marginTop: 0, color: 'rgba(0, 0, 0, 0.54)' },
  text: {
    fontWeight: 'normal',
    whiteSpace: 'nowrap',
    minHeight: '1.2em',
    padding: '0px 2px 0px',
    color: 'black'
  },
  disabled: {
    pointerEvents: 'none',
    opacity: 0.6
  }

});
